import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

const SewaClientDetail = ({ customer, onClose }) => {
  if (!customer) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center px-4 z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl p-6 relative overflow-y-auto max-h-[90vh]">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-gray-500 hover:text-red-500 text-xl"
        >
          <FontAwesomeIcon icon={faClose} />
        </button>

        <h2 className="text-xl font-bold mb-4 text-gray-700">
          Sewa Client Detail
        </h2>

        {/* Detail Grid */}
        <div className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm">
          <p className="text-gray-600">ID</p>
          <p>{customer.id}</p>

          <p className="text-gray-600">KPI Type</p>
          <p>{customer.kpiType}</p>

          <p className="text-gray-600">KPI</p>
          <p>{customer.kpi}</p>

          <p className="text-gray-600">Zone ID</p>
          <p>{customer.zoneId}</p>

          <p className="text-gray-600">Area ID</p>
          <p>{customer.areaId}</p>

          <p className="text-gray-600">Kawasan (Rental Area)</p>
          <p>{customer.rentalArea}</p>

          <p className="text-gray-600">Kategori Sewa</p>
          <p>{customer.rentalCategory}</p>

          <p className="text-gray-600">Nama</p>
          <p>{customer.name}</p>

          <p className="text-gray-600">No Kad Pengenalan</p>
          <p>{customer.identificationNumber}</p>

          <p className="text-gray-600">No Unit</p>
          <p>{customer.unitNumber}</p>

          <p className="text-gray-600">No Harta</p>
          <p>{customer.propertyNumber}</p>

          <p className="text-gray-600">No Akaun</p>
          <p>{customer.accountNumber}</p>

          <p className="text-gray-600">Status</p>
          <p
            className={`font-semibold ${
              customer.status?.toLowerCase() === "aktif"
                ? "text-green-600"
                : "text-red-600"
            }`}
          >
            {customer.status}
          </p>

          <p className="text-gray-600">Penerima Bantuan (Aid Recipient)</p>
          <p>{customer.aidRecipient}</p>

          <p className="text-gray-600">Potongan Gaji</p>
          <p>{customer.salaryDeduction}</p>

          <p className="text-gray-600">Kadar Sewa (Rental Rate)</p>
          <p>RM {customer.rentalRate?.toFixed(2)}</p>

          <p className="text-gray-600">Diskaun</p>
          <p>{customer.discount}</p>

          <p className="text-gray-600">Caj Sewa</p>
          <p>RM {customer.rentalCharge?.toFixed(2)}</p>

          <p className="text-gray-600">Tunggakan (Arrears)</p>
          <p>RM {customer.arrears?.toFixed(2)}</p>

          <p className="text-gray-600">Bayaran (Payment)</p>
          <p>RM {customer.payment?.toFixed(2)}</p>

          <p className="text-gray-600">Dicipta Pada</p>
          <p>{new Date(customer.createdAt).toLocaleString()}</p>

          <p className="text-gray-600">Dikemaskini Pada</p>
          <p>{new Date(customer.updatedAt).toLocaleString()}</p>
        </div>
         <Link to={`/sewa-client-update/${customer.id}`} className="  w-full">
          <button className="py-2 mt-3 px-3 w-full rounded-lg bg-yellow-600 text-white">Edit</button>
          </Link>
      </div>
    </div>
  );
};

export default SewaClientDetail;
